import classnames from 'classnames';
import React from 'react';

import { colors } from 'reactApp/variables';

export function IconUploadFile({
    width = '16',
    height = '16',
    className = '',
    fill = colors.activityGrey,
    ...rest
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            className={classnames(className)}
            {...rest}
        >
            <defs>
                <path
                    d="M7 12.384l-.384.383a.999.999 0 1 1-1.414-1.414l2.06-2.06A.999.999 0 0 1 8 9a.999.999 0 0 1 .738.293l2.06 2.06a1 1 0 0 1-1.414 1.414L9 12.384V15a1 1 0 0 1-2 0v-2.616zm-3.698.618l-.058.001A3.246 3.246 0 0 1 0 9.758c0-1.31.779-2.44 1.898-2.952a3.289 3.289 0 0 1 3.535-4.548 4.142 4.142 0 0 1 7.798 2.385A4.328 4.328 0 0 1 16 8.679a4.328 4.328 0 0 1-3.273 4.195 2.607 2.607 0 0 0-.645-2.624L9.844 8.012a2.588 2.588 0 0 0-1.829-.764h-.022a2.603 2.603 0 0 0-1.851.764L3.904 10.25a2.611 2.611 0 0 0-.602 2.752z"
                    id="path-1"
                />
            </defs>
            <g id="Load-Balancer" fill="none" fillRule="evenodd">
                <g
                    id="23-14-MCS-Load-Balancer-New-Rule-HTTPS-Certificate-First-Page-New-Certificate"
                    transform="translate(-975 -642)"
                >
                    <g id="Popup-Copy" transform="translate(343 43)">
                        <g id="Group-10" transform="translate(0 20)">
                            <g id="name-copy-6" transform="translate(10 571)">
                                <g id="bday">
                                    <g
                                        id="select-/-triple-combined-select"
                                        transform="translate(190)"
                                    >
                                        <g
                                            id="icon--/--upload"
                                            transform="translate(432 8)"
                                        >
                                            <path id="BG" d="M0 0h16v16H0z" />
                                            <mask id="mask-2" fill="#fff">
                                                <use xlinkHref="#path-1" />
                                            </mask>
                                            <use
                                                id="P_Cloud_Upload_16x16"
                                                fill={fill}
                                                xlinkHref="#path-1"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default IconUploadFile;
